/* ==========================================================================
   Flavour dropdown -> gallery hero photo, from the flavours grid.

   The gallery already swaps its hero frame for any dropdown option carrying
   data-hero (see apply() in product-giorgio-*-gallery.js). Coffee and tea
   get that attribute from the variant's own image. The biscotti, the cookies
   and the candles cannot: their variants carry no per-flavour photograph in
   Shopify. What they do have is the "Our ... Flavors" grid further down the
   page, one photograph per flavour, chosen by the client -- so that is where
   the hero comes from.

   This listens for the click in the CAPTURE phase and writes data-hero onto
   the option BEFORE the gallery's own handler reads it; the gallery then does
   exactly what it does for a coffee roast. Nothing is patched in that file.

   A document-level listener survives Dawn re-rendering the info column on
   every variant change, which is also why this runs once per page rather
   than per render. Matching is by name, normalised (case, punctuation): the
   grid says "Lavender + Sage Soy Candle" where the option says "Lavender +
   Sage", so a prefix match is accepted as well as an exact one. Collections
   ("Signature Collection") have no card and are left alone.

   A page opened on one flavour (?variant=...) needs nothing from here: the
   gallery snippet starts the frame on that variant's own photograph.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__gioFlavorHero) return;
  window.__gioFlavorHero = true;

  function norm(s) {
    return String(s || '').toLowerCase().replace(/&amp;/g, '&').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function lookup(value) {
    var want = norm(value);
    if (!want) return null;
    var items = document.querySelectorAll('[data-gio-flavors-source] .flavor-item');
    var best = null;
    for (var i = 0; i < items.length; i++) {
      var h = items[i].querySelector('h3');
      var img = items[i].querySelector('img');
      if (!h || !img) continue;
      var have = norm(h.textContent);
      var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src');
      if (!src) continue;
      if (have === want) return { src: src, label: h.textContent.trim() };
      if (!best && (have.indexOf(want) === 0 || want.indexOf(have) === 0)) best = { src: src, label: h.textContent.trim() };
    }
    return best;
  }

  document.addEventListener(
    'click',
    function (event) {
      var opt = event.target && event.target.closest && event.target.closest('.fd-option');
      if (!opt || opt.hasAttribute('data-hero')) return;
      var wrap = opt.closest('[data-gio-hero-from-grid]');
      if (!wrap) return;
      var hit = lookup(opt.getAttribute('data-value'));
      if (!hit) return;
      opt.setAttribute('data-hero', hit.src);
      opt.setAttribute('data-hero-label', hit.label);
    },
    true
  );
})();